// extracted by mini-css-extract-plugin
export default {"paymentSection":"O8-z","disabled":"P8-z"};